import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-route-loader",
  role: "status",
  "aria-live": "polite",
  "aria-label": "Chargement de la page"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", {
          class: "app-route-loader__bar",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("div", { class: "app-route-loader__badge" }, [
          _createElementVNode("i", {
            class: "fa fa-spinner fa-spin",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", null, "Chargement...")
        ], -1)
      ]))]))
    : _createCommentVNode("", true)
}